import { VideoRequestParams } from './interfaces/videoRequest'
import getMarketTrackingProperties from './utils/getMarketTrackingProperties'
import getVideoRequestAnalyticsProperties from './utils/getVideoRequestAnalyticsProperties'

const trackVideoRequestDownloaded = async (
  paramaters: VideoRequestParams,
): Promise<void> => {
  const { request } = paramaters

  const { videoRequestDownloaded } = await import('./sdk')
  videoRequestDownloaded({
    ...getVideoRequestAnalyticsProperties(request),
    ...getMarketTrackingProperties(),
    isBoughtByVisitor: false,
  })
}

export default trackVideoRequestDownloaded
